import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import {
  getPlatformsAction,
  initializeAction,
  selectPlatformAction,
  selectRegionAction,
} from "store/Slices/dashboardReducer";

export const useDashboardSettings = () => {
  const dispatch = useDispatch();
  const {
    isLoading,
    platforms,
    platform,
    regions,
    region,
    featureFlags,
    error,
  } = useSelector((state: RootState) => state.dashboard);

  const checkFeature = (permission: string) => {
    if (!featureFlags?.[permission]) {
      return false;
    }

    const platformId = platform?.id;
    const regionId = region?.id || 1;

    // First check platform-specific setting
    if (platformId && featureFlags[permission][platformId]?.[regionId] !== undefined) {
      return featureFlags[permission][platformId][regionId];
    }

    // Fall back to default setting (null platform)
    return featureFlags[permission]['default']?.[regionId] ?? false;
  };

  const onPlatformChange = (newPlatformId: number) => {
    const newValue = platforms?.find((el) => el.id === newPlatformId);
    if (newValue) {
      dispatch(selectPlatformAction(newValue));
    }
  };

  const onRegionChange = (newRegionId: number) => {
    const newValue = regions?.find((el) => el.id === newRegionId);
    if (newValue) {
      dispatch(selectRegionAction(newValue));
    }
  };

  const initializeDashboard = () => {
    dispatch(initializeAction());
  };

  const refetchPlatforms = () => {
    dispatch(getPlatformsAction());
  };

  return {
    isLoading,
    platforms,
    selectedPlatform: platform,
    regions,
    selectedRegion: region,
    regionId: region?.id,
    initializeDashboard,
    refetchPlatforms,
    onPlatformChange,
    onRegionChange,
    featureFlags,
    checkFeature,
  };
};
